import { configureStore } from "@reduxjs/toolkit";

import stock from "reducers/stock";
import supplier from "reducers/supplier";
import product from "reducers/product";
import order from "reducers/order";
import purchase from "reducers/purchase";
import view from "reducers/view";
import customer from "reducers/customer";

export default configureStore({
  reducer: { stock, supplier, product, view, order, purchase, customer },
});
